/**
 * View component for /metric-categories/:metricCategoryId/update
 *
 * Updates a single metricCategory from a copy of the selcted metricCategory
 * as defined in the metricCategory reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as metricCategoryActions from '../metricCategoryActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import metricCategory components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import MetricCategoryForm from '../components/MetricCategoryForm.js.jsx';

class UpdateMetricCategory extends Base {
  constructor(props) {
    super(props);
    const { selectedMetricCategory, metricCategoryMap } = this.props;
    this.state = {
      metricCategory: metricCategoryMap[selectedMetricCategory.id] ? { ...metricCategoryMap[selectedMetricCategory.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(metricCategoryActions.fetchSingleIfNeeded(match.params.metricCategoryId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedMetricCategory, metricCategoryMap } = nextProps;
    this.setState({
      metricCategory: metricCategoryMap[selectedMetricCategory.id] ? { ...metricCategoryMap[selectedMetricCategory.id] } : {}
      //we don't want to actually change the store's metricCategory, just use a copy
    })
  }

  _handleFormChange(e) {
    var newMetricState = _.update( this.state.metricCategory, e.target.name, function() {
      return e.target.value;
    });
    this.setState({metricCategory: newMetricState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(metricCategoryActions.sendUpdateMetricCategory(this.state.metricCategory)).then((action) => {
      if(action.success) {
        history.push(`/admin/authoring/metric-categories/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { location, selectedMetricCategory, metricCategoryMap } = this.props;
    const { metricCategory } = this.state;
    const isEmpty = (!metricCategory || metricCategory.title === null || metricCategory.title === undefined);
    return  (
      <AuthoringLayout>
        <div className="flex"> 
        <Helmet
          title={"Update Metric Category | Pro-ficiency"}
        />
          <section className="section">
            {isEmpty
              ? (selectedMetricCategory.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
            : <MetricCategoryForm
                metricCategory={metricCategory}
                cancelLink={`/admin/authoring/metric-categories/${metricCategory._id}`}
                formTitle="Update Metric Category"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
    </AuthoringLayout>
    )
  }
}

UpdateMetricCategory.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedMetricCategory: store.metricCategory.selected
    , metricCategoryMap: store.metricCategory.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateMetricCategory)
);



// WEBPACK FOOTER //
// modules/metricCategory/views/UpdateMetricCategory.js.jsx